
import { ElForm } from 'element-ui/types/form'
import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'

@Component({})
export default class Contact extends Vue {
    @Prop({ default: false }) private loading!: boolean
    @Prop({ default: '' }) private memo!: string
    @Ref('memoRef') private memoRef!: ElForm

    private DialogVisible: boolean = false
    private loadingInstance: any = ''
    private memoForm: any = {
        memo: ''
    }
    private memoRules: any = {
        memo: [
            { required: true, max: 1000, min: 1, message: '请按要求输入备注内容' }
        ]
    }

    @Watch('memo')
    private onMemoChange(memo: string) {
        this.memoForm.memo = memo
    }

    @Watch('loading')
    private onLoadingChange(loading: boolean) {
        if (loading) {
            this.loadingInstance = this.$loading({
                lock: true,
                text: '设置中',
                target: '.contact .el-dialog'
            })
        } else {
            this.loadingInstance && this.loadingInstance.close()
        }
    }

    private created() {
        this.memoForm.memo = this.memo
    }

    private close() {
        this.reset()
        this.DialogVisible = false
    }

    private onBeforeClose(done: Function) {
        this.reset()
        done()
    }

    private reset() {
        this.memoRef && this.memoRef.resetFields()
    }

    private show() {
        this.DialogVisible = true
    }

    private onSend() {
        this.memoRef.validate((isValid: boolean) => {
            if (isValid) {
                return this.$emit('send', this.memoForm)
            }
        })
    }
}
